module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subjects text-dark",
    class: {
      'subjects--is-activities': _vm.isActivities
    }
  }, [(!_vm.isActivities) ? _c('div', {
    staticClass: "subjects-header"
  }, [_c('div', {
    staticClass: "subjects-header__left"
  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['headline']))]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['subjects'],
      "tags": _vm.subjectTypeFilters,
      "selectedTags": _vm.selectedSubjectTypeFilters
    },
    on: {
      "select": _vm.toggleSelectedSubjectTypeFilters,
      "clear": _vm.clearSelectedSubjectTypeFilters
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "subjects-header__right"
  }, [(!_vm.isLoading && _vm.klassesWithoutSubjects.length > 0) ? _c('button', {
    staticClass: "do-bttn do-bttn--large",
    on: {
      "click": _vm.setImportSubjects
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['import_subjects']) + "\n      ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "color": "blue"
    }
  }) : [(_vm.klassCalIdsHashSortedOnName.length < 1) ? _c('div', [_c('h2', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_classes_first']))])]) : _c('div', {
    staticClass: "subjects-table",
    style: ({
      'width': _vm.tableWidth
    })
  }, [_c('table', {
    staticClass: "d-table"
  }, [_c('thead', {
    ref: "tableHead"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "160px"
    }
  }), _vm._v(" "), _vm._l((_vm.klassCalIdsHashSortedOnName), function(calId) {
    return _c('th', [_c('div', {
      staticClass: "column-name"
    }, [_vm._v(_vm._s(_vm.getCalendarName(calId)))])])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.klassCalIdsHashSortedOnName), function(calId) {
    return _c('td', {
      key: calId,
      staticClass: "td-create-bttn-container"
    }, [_c('button', {
      staticClass: "do-bttn td-bttn--small",
      on: {
        "click": function($event) {
          return _vm.setCreateInCalendarId(calId)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create']) + "\n            ")])])
  })], 2), _vm._v(" "), _vm._l((_vm.subjectsInKlassesWithProps), function(subject) {
    return _c('tr', {
      key: subject.id
    }, [_c('th', [_vm._v(_vm._s(subject.name))]), _vm._v(" "), _vm._l((_vm.klassCalIdsHashSortedOnName), function(calId) {
      return (subject.klasses[calId] && subject.klasses[calId].hours > -1) ? _c('td', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: true,
            onShow: function () { return subject.klasses[calId].v_subjectHasTeachers; }
          }),
          expression: "{\n                  arrow: true,\n                  onShow: () => subject.klasses[calId].v_subjectHasTeachers\n                }"
        }],
        key: calId,
        staticClass: "td__subject",
        class: [{
            'td__subject--has-user': subject.klasses[calId].v_subjectHasTeachers
          },
          {
            'td__subject--has-room': subject.klasses[calId].v_subjectHasRooms
          },
          {
            'td__subject-has-other-klass': subject.klasses[calId].v_subjectOtherKlasses && subject.klasses[calId].v_subjectOtherKlasses.length > 0
          }
        ],
        style: ({
          '--subjectBgColor': subject.klasses[calId].color
        }),
        attrs: {
          "aria-hours": subject.klasses[calId].hours,
          "content": subject.klasses[calId].v_userNames
        },
        on: {
          "click": function($event) {
            return _vm.setEditSubject(subject.klasses[calId])
          }
        }
      }) : _c('td', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            animateFill: false,
            animation: 'shift-away',
            zIndex: '999999992',
            boundary: 'window',
          }),
          expression: "{\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n                }"
        }],
        staticClass: "td__create-subject",
        attrs: {
          "content": _vm.createTooltip(subject, calId)
        },
        on: {
          "click": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            return _vm.setIsCreateSubject(subject, subject.klasses[calId])
          }
        }
      }, [(_vm.isCreateSubject(subject, subject.klasses[calId])) ? _c('AddSubject', {
        attrs: {
          "subject": subject,
          "calendar": subject.klasses[calId]
        },
        on: {
          "createSubject": _vm.createExistingSubjectInCal,
          "close": _vm.closeIsCreateSubject
        }
      }) : _vm._e()], 1)
    })], 2)
  })], 2)])])], _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
    attrs: {
      "propCalendarId": _vm.createInCalendarId,
      "showModal": _vm.isSubjectModal,
      "editSubject": _vm.editSubject,
      "isActivities": _vm.isActivities
    },
    on: {
      "close": _vm.closeModal,
      "createSubject": _vm.createNewSubject,
      "updateSubject": _vm.updateSubject,
      "deleteSubject": _vm.deleteSubject
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a690d52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/BulkCreateSubjects.vue
// module id = 1530
// module chunks = 1